define('gameday-index-gdaudio/subcomponents/AudioPlaybackComponent',['require','exports','module','jquery','message-service/message-service','app-console/app-console','extant/extant'],function(require, exports, module) {
	var $ = require("jquery"),
		MessageService = require("message-service/message-service"),
		logg = require("app-console/app-console"),
		exists = require("extant/extant");

	var CONTENT = "{CID}",
		URL = "{MEDIA_URL}",
		SKIN = "{SKIN}",
		VC_PATH = "/gameday/wrapper/v2/RC1/subcomponents/videoframe.html?width=300&height=169&property=mlb&cacheBust=1400786315115&autoplay=true&content_id={CID}&path={MEDIA_URL}&skin={SKIN}",
		FRAME_ID = "gdAudioPlaybackComponent",
		GDHeaderContent = "#GDHeaderContent";

	var targetDiv,
		contentID,
		mediaPath,
		station,
		audioFrame,
		historyEraser,
		isPlaying = true;

	function AudioPlaybackComponent (compID, feed, url) {
		logg.log("break 1");
		targetDiv = compID;
		contentID = feed.contentID;
		mediaPath = url;
		station = feed.station;

		writePlayerToPage();
		
	}

	function writePlayerToPage() {
		audioFrame = document.createElement("iframe");
		$(audioFrame).attr({ "id": FRAME_ID, "width": "1", "height": "1"});
		audioFrame.src = VC_PATH.replace(CONTENT, contentID).replace(URL, escape(mediaPath)).replace(SKIN, "none");
		$(audioFrame).appendTo(targetDiv);
		$(audioFrame).css({ "position": "absolute", "top": 0, "left": 0 });

		historyEraser = document.createElement("div")
		$(historyEraser).addClass("audioPlayerControlPlaying");
		$(historyEraser).appendTo(targetDiv);
		$(historyEraser).on("click", handlePlayPause);
		$(historyEraser).text("" + station);
		$(targetDiv).css("width", "155px");
		isPlaying = true;
		MessageService.publish("gdidx::writePlayerToPage");		
	}

	function handlePlayPause() {
		var player = getPlayerRef();

		if (isPlaying) {
			player.pause();
			$(historyEraser).addClass("audioPlayerControlPaused");
			isPlaying = false;
		} else {
			player.play();
			$(historyEraser).removeClass("audioPlayerControlPaused");
			isPlaying = true;
		}
	}

	AudioPlaybackComponent.prototype = {
		currentFeed: null,
		loadFeed: function(feed, feedURL) {
			var audioPlayer = getPlayerRef();

			if (exists(audioPlayer)) {
				contentID = feed.contentID;
				mediaPath = feedURL;
				station = feed.station;

				audioPlayer.play(contentID, escape(mediaPath), true);

				$(historyEraser).text(station);
				isPlaying = true;

				$(historyEraser).removeClass("audioPlayerControlPaused");
			} else {
				logg.log("COULD NOT LOCATE THE AUDIO PLAYBACK UNIT, TOOL.")
			}
		}
	};

	function getPlayerRef() {
		var audioPlayer;
		if (!exists(audioFrame)) { audioFrame = doc.getElementById(FRAME_ID); }
		if (exists(audioFrame)) { audioPlayer = audioFrame.contentWindow.gdvideo;}
		return audioPlayer;
	}

	return AudioPlaybackComponent;
});
